import React from 'react';
import { UserInfoProps } from './types';
import { AvatarCornerIcon, AvatarWrapper, MainInfo, MainInfoWrapper, NameWrapper, Wrapper } from './user-info.styles';
import { Typography } from '../../../../../shared/ui/typography/typography';
import { AllLock } from '@vtbhome/juicyfront/indexIcon';
import { COLORS } from '../../../../../shared/config/colors/colors';
import { Photo } from '@shared/ui/photo/photo';
import { UserInfoTooltip } from '@shared/ui/user-info-tooltip/user-info-tooltip';

export const UserInfo: React.FC<UserInfoProps> = ({
    name,
    departmentName,
    email,
    phoneNumber,
    organizationPost,
    status,
    avatarUrl,
    children,
}) => {
    return (
        <Wrapper>
            <MainInfoWrapper>
                <AvatarWrapper>
                    <Photo photoUrl={avatarUrl} name={name} size='xxxl' />
                    {status === 'disabled' && (
                        <AvatarCornerIcon>
                            <AllLock color={COLORS.error_60} />
                        </AvatarCornerIcon>
                    )}
                </AvatarWrapper>
                <MainInfo>
                    <NameWrapper>
                        <Typography size='h6'>{name}</Typography>
                        <UserInfoTooltip
                            tooltipProps={{ position: 'top' }}
                            tooltipData={{
                                departmentName,
                                email,
                                phoneNumber,
                            }}
                        />
                    </NameWrapper>
                    <Typography size='body1_short' color='neutral_50'>
                        {organizationPost}
                    </Typography>
                </MainInfo>
            </MainInfoWrapper>
            {children}
        </Wrapper>
    );
};
